var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21V3H21V21H3ZM19.5 15.13V4.5H4.5V11.51L8.02 7.99L13.76 13.73L15.93 11.56L19.5 15.13ZM8.02 10.11L4.5 13.63V19.5H7.99L12.7 14.79L8.02 10.11ZM15.93 13.68L10.11 19.5H19.5V17.25L15.93 13.68ZM17.5 8.24C17.5 9.76 16.27 10.99 14.75 10.99C13.23 10.99 12 9.76 12 8.24C12 6.72 13.23 5.49 14.75 5.49C16.27 5.49 17.5 6.72 17.5 8.24ZM16 8.24C16 7.55 15.44 6.99 14.75 6.99C14.06 6.99 13.5 7.55 13.5 8.24C13.5 8.93 14.06 9.49 14.75 9.49C15.44 9.49 16 8.93 16 8.24Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Image_icon.a5a0e4b5eb29f3f12e176852ed256c4e.svg";